import Signaler from '@customink/signalerjs';
import {HANES_ESSENTIAL, HANES_TAGLESS} from '~/constants/ProductConstants';

export const SIMPLE_PRICING_FLAG = 'simple_pricing_v7';
export const UPLOAD_ONE_COLOR_FLAG = 'uploadOneColor_v2';
export const UPLOAD_AUTO_SIZING_FLAG = 'upload_auto_sizing_v3';
export const WAYS_TO_ORDER_FLAG = 'ways_to_order_v6';

/*
 Rules:
 - Sum of all variants of `flags` should be 1
 - When you are changing rollout values of `flags`, you might consider changing name of feature flag, based on D&A req (for example add_to_cart_notification_v0 -> add_to_cart_notification_v1)
 - you can change value of feature flag in console, e.g. window.signaler.setFeatureFlag('add_to_cart_notification_v0', 'test')
 - docs https://github.com/customink/signalerjs/tree/master
 */
export const featuresDefinition = {
  autoFitText: {
    flags: {
      test1: 0,
      test2: 0,
      test3: 0,
      test4: 0,
      test5: 0,
      test6: 0,
      control: 0,
      excluded: 1
    }
  },
  defaultBlank_v9: {
    flags: {
      [HANES_TAGLESS.flagName]: 0,
      [HANES_ESSENTIAL.flagName]: 0,
      excluded: 1
    }
  },
  embroiderySleeveStyles_v2: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  singlesPricingMessage_v4: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  uploadColorRemoval: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  uploadResolution_v3: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  [UPLOAD_ONE_COLOR_FLAG]: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  decoration_overrides_v1: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  [SIMPLE_PRICING_FLAG]: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    },
    launchDate: '2024 12 12'
  },
  [UPLOAD_AUTO_SIZING_FLAG]: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  [WAYS_TO_ORDER_FLAG]: {
    flags: {
      test: 0.1,
      control: 0.1,
      excluded: 0.8
    },
    launchDate: '2025 04 07'
  }
} as const satisfies Record<string, FeatureDefinition>;

export type FeatureDefinition = {
  // readability note: consistent term for this field would have been `variations` or `possibleValues`, but the signaler.js library prescribes `flags`
  flags: Record<string, number>;
  launchDate?: `${number} ${number} ${number}`; // "YYYY MM DD"
};

export type SignalerFeatureFlagName = keyof typeof featuresDefinition;

export const signaler = new Signaler(featuresDefinition);
window.signaler = signaler;
